import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() button3rdEnable:boolean;
  @Input() button3rdText:string

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  
  public decline() {
    this.activeModal.dismiss(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public close() {
    this.activeModal.close(false);
  }

}

